import { HttpClient } from "./HttpClient"

export const BitacoraService = {
    async getUsers(){
        return await HttpClient.get(`/user/get-by-dispatch`).then(response => response);
    },

    async getBitacoras(start_date,end_date,module,user){
        return await HttpClient.get(`/log/get-info-log/${start_date}/${end_date}/${module}/${user}`).then(response => response)
    },

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },
}